import { Box, Divider, Grid, Typography } from "@mui/material";
import Drawer, { IDefaultDrawerProps } from "../Drawer";
import { useLanguageContext } from "../../contexts/LanguageContext";
import { GovernanceStatusData, OccupancyStatusData, RoomStatusData } from "../../data/Enums";
import RoomCard from "./RoomCard";
import { useMemo } from "react";
import { IRoom } from "../../interfaces/IPartnerPms";
import DefaultConstants from "../../data/Constants";



const Legend: React.FC<IDefaultDrawerProps> = ({
    open,
    handleClose
}) => {
    const { translate } = useLanguageContext();


    const emptyRoom = useMemo(() => {
        return {
            id: 0,
            description: '',
            occupancyStatusId: 'Legend',
            governanceStatusId: 'Legend',
            roomTypeId: 0,
            blockId: 0,
            floorId: 0
        } as IRoom;
    }, []);


    return (
        <Drawer
            anchor='right'
            open={open}
            handleClose={handleClose}
            title={translate('legend')}
        >
            <Grid container rowSpacing={DefaultConstants.gridRowSpacing} columnSpacing={DefaultConstants.gridColumnSpacing}>
                <Grid item xs={12}>
                    <Typography variant='subtitle2' className='fontweight-600'>{translate('occupancyStatus')}</Typography>
                </Grid>

                {
                    Object.values(OccupancyStatusData).filter(s => s.partnerId).map(s => {
                        return <Grid item md={6} xs={6} key={s.key}>
                            <RoomCard
                                key={s.key}
                                room={{
                                    ...emptyRoom,
                                    description: translate(s.name),
                                    occupancyStatusId: s.partnerId ?? ''
                                }}
                                showGovernanceTooltip={false}
                                className="animation-none"
                            />
                        </Grid>;
                    })
                }
            </Grid>

            <Box marginTop={4} marginBottom={2}>
                <Divider />
            </Box>

            <Grid container rowSpacing={DefaultConstants.gridRowSpacing} columnSpacing={DefaultConstants.gridColumnSpacing}>
                <Grid item xs={12}>
                    <Typography variant='subtitle2' className='fontweight-600'>{translate('governanceStatus')}</Typography>
                </Grid>

                {
                    Object.values(GovernanceStatusData).filter(s => s.partnerId).map(s => {
                        return <Grid item md={6} xs={6} key={s.key}>
                            <RoomCard
                                key={s.key}
                                room={{
                                    ...emptyRoom,
                                    description: translate(s.name),
                                    governanceStatusId: s.partnerId ?? ''
                                }}
                                showGovernanceTooltip={false}
                                className="animation-none"
                            />
                        </Grid>;
                    })
                }
            </Grid>

            <Box marginTop={4} marginBottom={2}>
                <Divider />
            </Box>

            <Grid container rowSpacing={DefaultConstants.gridRowSpacing} columnSpacing={DefaultConstants.gridColumnSpacing}>
                <Grid item xs={12}>
                    <Typography variant='subtitle2' className='fontweight-600'>{translate('roomStatus')}</Typography>
                </Grid>

                {
                    Object.values(RoomStatusData).filter(s => s.partnerId).map(s => {
                        const key = s.partnerId as keyof(IRoom);

                        return <Grid item md={6} xs={6} key={s.key}>
                            <RoomCard
                                key={s.key}
                                room={{
                                    ...emptyRoom,
                                    description: translate(s.name),
                                    [key]: true
                                }}
                                showGovernanceTooltip={false}
                                className="animation-none"
                            />
                        </Grid>;
                    })
                }
            </Grid>
        </Drawer>
    )
}

export default Legend;